import React from "react";

import { useCheckPasswordStrength, useTranslation } from "utils";

import { Col, Input, InputPassword, PasswordStrengthPopup, Row } from "components";

export const PasswordResetInputs = () => {
  const { t } = useTranslation("signinup");
  const { setPasswordMatch, setPasswordStrength, currentPasswordStrength } = useCheckPasswordStrength();

  const handlePasswordChange = (e: React.ChangeEvent<Element>, inputNumber: number) => {
    if (inputNumber === 1) {
      setPasswordStrength(e);
    }

    if (inputNumber === 2) {
      setPasswordMatch(e);
    }
  };

  return (
    <>
      <Row>
        <Col>
          <Input
            name="email"
            label={t("changePassword.inputs.email")}
            rules={[
              {
                required: true,
                type: "email",
              },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12}>
          <InputPassword
            name="password"
            label={t("changePassword.inputs.password")}
            PasswordStrengthPopup={<PasswordStrengthPopup currentPasswordStrength={currentPasswordStrength} />}
            rules={[{ required: true }]}
            onChange={(e) => handlePasswordChange(e, 1)}
          />
        </Col>
        <Col sm={12} md={12}>
          <InputPassword
            name="confirmPassword"
            label={t("changePassword.inputs.confirmPassword")}
            PasswordStrengthPopup={<PasswordStrengthPopup currentPasswordStrength={currentPasswordStrength} />}
            rules={[{ required: true }]}
            onChange={(e) => handlePasswordChange(e, 2)}
          />
        </Col>
      </Row>
    </>
  );
};
